export const COMPANY_NAME = 'AGUA AMIGAO';
export const COMPANY_CNPJ = '18.008.915/0001-09';
export const COMPANY_PHONE = '(82) 3327-1052';
